import React from 'react'
import Url from '../../src/Url';
const currentYear = new Date().getFullYear();

function Footerlast() {
  return (
    <div className="footer-bottom-container">
    <div className="footer-content">
      <a
        href="https://www.dmca.com/Protection/Status.aspx?ID=cdbee84b-69c5-4d57-af58-7b9a85e07075"
        title="DMCA.com Protection Status"
        className="dmca-badge"
        aria-label="Visit DMCA"
      >
        <img
          src={`${Url.imageUrl}opt/dmca.webp`}
          alt="DMCA.com Protection Status"
          width={90}
          height={90}
          loading="lazy"
        />
      </a>
      <p className="copyright">
        Copyright &copy; {currentYear} tr
        <span className="brand-highlight">AI</span>
        lique technologies. All Rights Reserved  &nbsp;
        <a href="/privacy-policy" style={{marginLeft:"3px"}}>Privacy Policy</a> - <a href="/terms-conditions">Terms & Conditions</a>
      </p>
      
       
    </div>
  </div>
  )
}

export default Footerlast